import Vue from 'vue';

export const getConfig = (configName) => {
    return Vue.prototype.$Env[configName] || process.env[configName];
}

export const getNotificationsApiUrl = () => {
    return getConfig("VUE_APP_NOTIFICATIONS_API_URL");
}

export const getValidateUserApiUrl = () => {
  return getConfig("VUE_APP_VALIDATE_USER_API_URL");
}

export const getNswSchoolSafetyApiUrl = () => {
    return getConfig("VUE_APP_NSW_SCHOOL_SAFETY_API_URL");
}

export const getEmailDomain = () => {
  return getConfig("VUE_APP_AUDIENCE_EMAIL_DOMAIN");
}
